<template>
  <v-card>
    <v-card-text class="">
      <v-container class="pa-0">
        <v-row style="height:50px;">
          <v-col cols="6">
            <div class="layout ma-0 justify-center align-center">
              <span class="cap">
                <v-icon size="28px" :color="color">{{icon}}</v-icon>
                {{title}}
              </span>
            </div>
          </v-col>
          <v-col cols="6" class="text-sm-center white--text">
            <span :class="color" style="font-size:29px;display:inline-block;width:90px;height:41px;margin-top:-10px;">{{ subTitle }}</span>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<style>
.cap {
  font-size: 16px;
  font-weight: bold;
}
.py-3 {
  padding-top: 12px !important;
  padding-bottom: 4px !important;
}
</style>

<script>
export default {
  props: {
    icon: String,
    title: String,
    subTitle: String,
    color: String
  }
}
</script>
